export default __webpack_public_path__ + "static/media/GAE. RAM GEST.da91fa9f.pdf";